// Vendors
import React, { useState } from 'react';
import axios from 'axios';

// Components
import { Loader } from '../components';
import {
  Appliances,
  BuilderDetails,
  CreatePdf,
  GasEpat,
  MainNotice,
  Messages,
  ProjectDetails,
  TransferProject,
  UpdateProjectStatus
} from './components';

const AdminPipProject = () => {
  const { builderMeta } = window.wlPipAdmin;
  const [loading, setLoading] = useState(false);
  const [projectData, setProjectData] = useState(window.wlPipProject);
  const [messages, setMessages] = useState(window.wlPipAdmin.projectComments);
  const [mainNotice, setMainNotice] = useState({ type: '', message: '' });
  const [showMainNotice, setShowMainNotice] = useState(false);
  const [projectMessage, setProjectMessage] = useState('');
  const [openAccordion, setOpenAccordion] = useState({
    'project-status': true,
    'basic-info': false,
    'builder-details': false,
    appliances: false,
    'gas-epat': false,
    'project-messages': false
  });

  const [newProjectStatus, setNewProjectStatus] = useState(
    window.wlPipProject.status
  );
  const [newCompletionDate, setNewCompletionDate] = useState(
    window.wlPipProject.completion_date
  );
  let _isSubscribed = false;
  const adminFilters = JSON.parse(localStorage.getItem('adminFilters'));

  const handleToggleAccordion = (accordion) => {
    const newOpenAccordion = { ...openAccordion };
    newOpenAccordion[accordion] = !newOpenAccordion[accordion];
    setOpenAccordion(newOpenAccordion);
  };

  const handleUpdateProjectDetails = (key) => {
    if (newCompletionDate === projectData.completion_date) return;

    setLoading(true);
    _isSubscribed = true;

    const formData = new FormData();
    formData.append('action', 'wl_pip_update_project');
    formData.append('pid', projectData.pid);
    //TODO: make key dynamic
    formData.append('completion_date', newCompletionDate);

    axios({
      method: 'post',
      url: window.wlPipConfig.ajaxUrl,
      data: formData
    })
      .then(({ data: { success, data } }) => {
        if (_isSubscribed) {
          setMainNotice({
            type: success ? 'success' : 'error',
            message: data.message
          });
          setShowMainNotice(true);
          setProjectMessage('');

          if (data.completion_date) {
            setProjectData({
              ...projectData,
              completion_date: data.completion_date
            });
          }

          if (mainNotice.type === 'error') {
            setNewCompletionDate(window.wlPipProject.completion_date);
          }

          setTimeout(() => setLoading(false), 250);

          _isSubscribed = false;
        }
      })
      .catch((error) => {
        setMainNotice({
          type: 'error',
          message: error
        });
        setShowMainNotice(true);
        setLoading(false);
      });
  };

  const handleUpdateStatus = () => {
    if (newProjectStatus === projectData.status) return;

    setLoading(true);
    _isSubscribed = true;

    const formData = new FormData();
    formData.append('action', 'wl_pip_set_status');
    formData.append('status', newProjectStatus);
    formData.append('message', projectMessage);
    formData.append('pid', projectData.pid);

    axios({
      method: 'post',
      url: window.wlPipConfig.ajaxUrl,
      data: formData
    })
      .then(({ data: { success, data } }) => {
        if (_isSubscribed) {
          setMainNotice({
            type: success ? 'success' : 'error',
            message: data.message
          });
          setShowMainNotice(true);
          setProjectMessage('');

          if (data.meta_fields) {
            setProjectData(data.meta_fields);
            setNewProjectStatus(data.meta_fields.status);
          }

          if (data.project_comments) {
            setMessages(data.project_comments);
          }

          setTimeout(() => setLoading(false), 250);

          _isSubscribed = false;
        }
      })
      .catch((error) => {
        setMainNotice({
          type: 'error',
          message: error
        });
        setShowMainNotice(true);

        setLoading(false);
      });
  };

  const getBackToMessage = () => {
    if (adminFilters.builder != '0') {
      return `Back to ${builderMeta.company}`;
    } else if (adminFilters.status || adminFilters.state) {
      return 'Back to filtered Dashboard';
    } else {
      return 'Back to Dashboard';
    }
  };

  if (loading === true || projectData === null) return <Loader />;

  return (
    <>
      <h5
        className="edit-form__back"
        onClick={() => (window.location.href = '/pcip/dashboard/')}
      >
        {getBackToMessage()}
      </h5>

      <h1 className="u--margin-top-0 u--color-blue-dark">
        {projectData.address}
      </h1>
      <div className="grid" style={{ maxWidth: '600px' }}>
        <div className="grid__col-xs-12 u--margin-bottom-20">
          <div className="project-info">
            <p className="u--margin-0">
              <strong>
                {builderMeta.first_name} {builderMeta.last_name} &mdash;{' '}
                {builderMeta.company}
              </strong>
              <br />
              {projectData.address}
              <br />
              {projectData.city}, {projectData.state} {projectData.zipcode}
            </p>
          </div>
        </div>

        <CreatePdf
          projectID={projectData.pid}
          builderMeta={builderMeta}
          _isSubscribed={_isSubscribed}
        />

        {showMainNotice === true && <MainNotice mainNotice={mainNotice} />}

        <TransferProject
          projectID={projectData.pid}
          builderMeta={builderMeta}
          _isSubscribed={_isSubscribed}
          setMainNotice={setMainNotice}
          setShowMainNotice={setShowMainNotice}
        />

        <UpdateProjectStatus
          projectData={projectData}
          openAccordion={openAccordion}
          handleToggleAccordion={handleToggleAccordion}
          newProjectStatus={newProjectStatus}
          setNewProjectStatus={setNewProjectStatus}
          projectMessage={projectMessage}
          setProjectMessage={setProjectMessage}
          handleUpdateStatus={handleUpdateStatus}
        />
        <ProjectDetails
          projectData={projectData}
          openAccordion={openAccordion}
          handleToggleAccordion={handleToggleAccordion}
          newCompletionDate={newCompletionDate}
          setNewCompletionDate={setNewCompletionDate}
          handleUpdateProjectDetails={handleUpdateProjectDetails}
        />
        <BuilderDetails
          builderMeta={builderMeta}
          openAccordion={openAccordion}
          handleToggleAccordion={handleToggleAccordion}
        />
        <Appliances
          projectData={projectData}
          openAccordion={openAccordion}
          handleToggleAccordion={handleToggleAccordion}
        />
        <GasEpat
          projectData={projectData}
          openAccordion={openAccordion}
          handleToggleAccordion={handleToggleAccordion}
        />
        <Messages
          projectID={projectData.pid}
          openAccordion={openAccordion}
          handleToggleAccordion={handleToggleAccordion}
          _isSubscribed={_isSubscribed}
          messages={messages}
          setMessages={setMessages}
        />
      </div>
    </>
  );
};

export default AdminPipProject;
